export const PREDPISY_A_PLATBY_ROUTE = "/predpisy-a-platby";